import { compose } from 'redux';
import { branch, renderComponent } from 'recompose';
import PropTypes from 'prop-types';
import { ADVERT_VIEW_MODE_TYPED } from '../../helpers/advert/advert';
import { GridView } from './views/grid';
import { SliderView } from './views/slider';

const AdvertLinkViewController = compose(
  branch(({ mode }) => mode === ADVERT_VIEW_MODE_TYPED.slider, renderComponent(SliderView))
)(GridView);

AdvertLinkViewController.displayName = 'AdvertLinkViewController';

AdvertLinkViewController.propTypes = {
  advertName: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(['grid', 'slider']),
  configuration: PropTypes.object
};

export { AdvertLinkViewController };
